module.exports = __webpack_public_path__ + "catalog/holes/door-double/door_double.png";